import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';

/** Shared PermissionGuard canActivate used by lazy page routes. */
export const pagePermissionActivate = [
    (route: any, state: any) => inject(PermissionGuard).canActivate(route, state),
];
